"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;
var _react = _interopRequireDefault(require("react"));
var _simple = require("./sections/simple");
var _chapter = require("./sections/chapter");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Section = ({
  id,
  scrollContainerId,
  sectionType,
  colorMode,
  vimeoId,
  backgroundColor,
  backgroundImage,
  textColor,
  initTimelines,
  children
}) => {
  const getSectionComponentAndProps = () => {
    let C;
    let props = {};
    switch (sectionType) {
      case 'Simple':
        C = _simple.Simple;
        props = {
          id,
          colorMode,
          backgroundColor,
          textColor,
          backgroundImage
        };
        break;
      case 'Chapter':
        C = _chapter.Chapter;
        props = {
          id,
          backgroundImage,
          vimeoId,
          initTimelines,
          textColor,
          backgroundColor,
          scrollContainerId
        };
        break;
      default:
        C = _simple.Simple;
        props = {
          id,
          colorMode,
          backgroundColor
        };
        break;
    }
    return {
      C,
      props
    };
  };
  const {
    C,
    props
  } = getSectionComponentAndProps();
  return _react.default.createElement(C, props, children);
};
exports.Section = Section;
//# sourceMappingURL=index.js.map